import { LinearProgress, Stack } from "@mui/material";
import { isEmpty, take } from "lodash";
import { useNavigate } from "react-router-dom";
import Actions from "../../components/actions/Actions";
import AddFab from "../../components/actions/AddFab";
import InfiniteScroll from "../../components/infiniteScroll/InfiniteScroll";
import { useLimit } from "../../misc/useLimit";
import { useOpenInNewTab } from "../../misc/useOpenInNewTab";
import { useAdminFiltersValue } from "../useAdminFilters";
import AgentCard from "./AgentCard";
import { useAgents } from "./useAgents";

const AgentsList = () => {
  const navigate = useNavigate();
  const { openChildInNewTab } = useOpenInNewTab();
  const { limit, loadMore } = useLimit();
  const { agents, isLoading } = useAgents();
  const { query } = useAdminFiltersValue("agents");

  const filteredAgents = (agents ?? []).filter((a) => isEmpty(query) || a.name.toLowerCase().includes(query));
  return (
    <Stack sx={{ height: "100%" }}>
      {isLoading && <LinearProgress />}
      <InfiniteScroll
        dataLength={limit < filteredAgents.length ? limit : filteredAgents.length}
        hasMore={limit < filteredAgents.length}
        fetchData={loadMore}
      >
        {take(filteredAgents, limit).map((a) => (
          <AgentCard
            key={a.id}
            value={{ ...a, notes: a.notes ?? [] }}
            onClick={() => navigate(a.id)}
            onContextMenu={() => openChildInNewTab(a.id)}
          />
        ))}
      </InfiniteScroll>
      <Actions>
        <AddFab label="dodaj przedstawiciela" onClick={() => navigate("new")} />
      </Actions>
    </Stack>
  );
};

export default AgentsList;
